import styled from 'styled-components';

export const UnsubscribeWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #ffffff;
`;

export const UnsubscribeCard = styled.div`
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
`;

export const UnsubscribeLogo = styled.div`
  margin-bottom: 12px;

  svg {
    height: 32px;
    width: auto;
  }
`;

export const UnsubscribeIcon = styled.div<{ $done: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({ $done }) => ($done ? 'rgba(16, 185, 129, 0.12)' : '#f3f4f6')};
  color: ${({ $done }) => ($done ? '#047857' : '#6b7280')};

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const UnsubscribeTitle = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.01em;
  color: #111111;
`;

export const UnsubscribeDescription = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #4b5563;
`;
